// ProtectedRoute.js
import { useSelector } from 'react-redux'
import { NavLink, Outlet } from 'react-router-dom'
import Layout from "../layout/Layout/Layout"

const ProtectedRoute = () => {
  const { userToken } = useSelector((state) => state.login)

  // show unauthorized screen if no user is found in redux store
  if (!userToken) {
    return (
      <div className='unauthorized'>
        <h1>Unauthorized :(</h1>
        <span>
          <NavLink to='/auth/login'>Login</NavLink> to gain access
        </span>
      </div>
    )
  }

  // returns child route elements
  return <Outlet/>
}
export default ProtectedRoute